import { AppImages } from "assets/appResources";
import { PublicationType } from "models/ApiEnums";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IPropsImage {
    publicationType: PublicationType;
    isInstitutional?: boolean;
    width?: number | string;
    height?: number | string;
}

/////////////////////////////////////////////////////////////////////////////////////

export function PublicationDefaultThumbnailUrl(publicationType: PublicationType, isInstitutional: boolean) {

    const url = isInstitutional === true
        ? AppImages.DefaultInstitutionalThumbnail
        : publicationType == null
            ? AppImages.DefaultPublicationThumbnail
            : publicationType == PublicationType.Answer
                ? AppImages.PublicationTypeAnswerThumbnail
                : publicationType == PublicationType.Course
                    ? AppImages.PublicationTypeCourseThumbnail
                    : publicationType == PublicationType.List
                        ? AppImages.PublicationTypeListThumbnail
                        : publicationType == PublicationType.Poll
                            ? AppImages.PublicationTypePollThumbnail
                            : publicationType == PublicationType.Post
                                ? AppImages.PublicationTypePostThumbnail
                                : publicationType == PublicationType.Question
                                    ? AppImages.PublicationTypeQuestionThumbnail
                                    : AppImages.DefaultPublicationThumbnail;

    return url;
};

export const PublicationTypeImage: React.FC<IPropsImage> = (props) => {
    const { t } = useTranslation("sys");
    const { publicationType, isInstitutional, width, height } = props;
    const url = PublicationDefaultThumbnailUrl(publicationType, isInstitutional);
    const alt = t(`PublicationType.${PublicationType[publicationType]}`);

    return (
        <img
            src={url}
            alt={alt}
            title={alt}
            width={width}
            height={height}
        />
    );
};
